// extracted by mini-css-extract-plugin
export default {"PartTwo":"Part2_PartTwo__iPOK4"};